import { Button, TableCell, TableRow } from '@mui/material';
import { format } from 'date-fns';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import { type LTICredential } from '../../../../types/apiTypes';
import getTimeFormatFromLocale from '../../../../utils/getTimeFormatFromLocale';
import AdminIntegrationsContainer from '../../AdminIntegrationsContainer';

interface IntegrationTableRowProps {
    data: LTICredential;
}

const StyledTableRow = styled(TableRow)``;

const StyledTableCell = styled(TableCell)`
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
`;

const { format: timeFormat } = getTimeFormatFromLocale();

const IntegrationTableRow: React.FC<IntegrationTableRowProps> = ({ data }) => {
    const { title, type, updated_at: updatedAt, lti_version: ltiVersion } = data;
    const lastUpdated = format(new Date(updatedAt), timeFormat);
    const history = useHistory();
    const { path } = useRouteMatch();
    const { setSelectedIntegration, setIntegrationId } = useContainer(AdminIntegrationsContainer);

    const handleClick = () => {
        setSelectedIntegration(data);
        setIntegrationId(data.lti_creds_uuid);
        history.push(`${path}/edit/${data.lti_creds_uuid}`);
    };

    return (
        <StyledTableRow>
            <StyledTableCell>
                <Button onClick={handleClick}>{title}</Button>
            </StyledTableCell>
            <StyledTableCell>{ltiVersion}</StyledTableCell>
            <StyledTableCell>{type}</StyledTableCell>
            <StyledTableCell>{lastUpdated}</StyledTableCell>
        </StyledTableRow>
    );
};

export default IntegrationTableRow;
